module.exports = __webpack_public_path__ + "img/36.8133cdec.jpg";